import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashiconsUpdateAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 26,
	viewBox: "0 0 25 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_5955_18311)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.79643 11.6071C6.35357 8.82143 8.86071 6.73214 11.7857 6.73214C13.875 6.73214 15.5464 7.70714 16.6607 9.23929L19.0286 6.45357C17.3571 4.50357 14.7107 3.25 11.7857 3.25C6.91071 3.25 2.87143 6.87143 2.175 11.6071H-0.75L4.125 17.1786L9 11.6071H5.79643ZM19.4464 8.82143L14.5714 14.3929H17.775C17.0786 17.1786 14.7107 19.2679 11.7857 19.2679C9.69643 19.2679 8.025 18.2929 6.91071 16.7607L4.54286 19.4071C6.21429 21.4964 8.86071 22.75 11.7857 22.75C16.6607 22.75 20.7 19.1286 21.3964 14.3929H24.3214L19.4464 8.82143Z",
			fill: "#79C912"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5955_18311",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 25,
			height: 25,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgDashiconsUpdateAlt;
